<template>

  <ul class="menu" :class="{'menu--main': type === 'main', 'menu--sub': type === 'sub'}">
    <li class="menu__item" v-if="items" v-for="item in currentItems">

      <router-link :to="`${item.link ? item.link : '/'}`">
        <span>{{ t(item.code) }}</span>
        <svg v-if="isHasChildren(item)" xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="black" stroke="black" class="bi bi-chevron-down" viewBox="0 0 16 16">
          <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>
        </svg>
      </router-link>

      <Menu
        v-if="isHasChildren(item)"
        :items="items"
        :id_top_position="item.id"
        type="sub"/>

    </li>
  </ul>

</template>

<script>
import View from "@/views/View.vue"

export default {
  name: "Menu",
  props: {
    items: {
      default() {
        return null
      }
    },
    type: {
      default() {
        return "main"
      }
    },
    id_top_position: {
      default() {
        return null
      }
    }
  },
  extends: View,
  methods: {
    /**
     * Sprawdza czy element menu zawiera podelementy
     * @param item element menu
     */
    isHasChildren(item) {
      return this.items.find(obj => obj.id_top_position === item.id)
    },
  },
  computed: {
    /**
     * Zwraca aktualne elementy menu
     */
    currentItems() {
      return this.items.filter(item => item.id_top_position === this.id_top_position)
    }
  }
}
</script>

<style scoped lang="scss">

.menu {
  list-style: none;
  display: flex;
  flex-direction: row;
  column-gap: 32px;

  @media screen and (max-width: 991px) {
    display: none;
  }

  &--main {
    height: 100%;

    & > .menu__item {
      height: inherit;

      & > a {
        height: inherit;
      }
    }
  }

  &--sub {
    display: block;
    width: 250px;
    position: absolute;
    top: 90%;
    left: -20%;
    opacity: 0;
    visibility: hidden;
    padding: 10px 0;
    background-color: #fff;
    box-shadow: 0 5px 20px 0 rgb(0 0 0 / 10%);
    transition: all 0.25s ease 0s;
    transform: scaleY(0);
    transform-origin: top;

    & > .menu__item {
      margin: 5px 0;

      & > a {
        display: block;
        padding: 2px 20px;
        line-height: 26.25px;

        & > span {
          font-size: 0.9375rem;
        }

        &::before {
          top: 50%;
          content: '';
          position: absolute;
          left: 20px;
          width: 0;
          height: 2px;
          border-radius: 1px;
          background: rgb(73, 78, 155);
          transition: all 0.25s ease 0s;
        }

        &:hover {
          padding-left: 35px;

          &::before {
            width: 7px;
          }
        }
      }
    }
  }

  &__item {
    position: relative;

    & > a {
      display: flex;
      flex-direction: row;
      align-items: center;
      column-gap: 5px;
      cursor: pointer;
      transition: all 0.25s ease 0s;

      & > span, & > svg {
        transition: all 0.25s ease 0s;
      }
    }

    &:hover {

      & > a {

        & > span {
          color: rgb(73, 78, 155);
        }

        & > svg {
          transform: rotate(-180deg);
          stroke: rgb(73, 78, 155);
        }
      }

      & > .menu--sub {
        opacity: 1;
        visibility: visible;
        transform: scaleY(1);
      }
    }
  }
}

html.contrast {


  & .menu {

    &--main {

      & > .menu__item {

        &:hover {

          & > a {

            & > span {
              color: #000;
            }

            &::before {
              background: #000;
            }
          }
        }
      }
    }

    &--sub {
      background-color: gold;

      & > .menu__item {

        &:hover {

          & > a {

            & > span {
              color: #000;
            }

            &::before {
              background: #000;
            }
          }
        }
      }
    }
  }
}

</style>